export const preserveSplitKitchenState = (item, unitIndex = 0) => {
  const amountToImpress = Number(item.amount_to_impress ?? item.amount ?? 1);
  const wasAlreadySentToKitchen = item.kitchen_action === "send_to_kitchen" && item.isNewAdd !== true;

  return {
    kitchen_action: item.kitchen_action || "send_to_kitchen",
    isNewAdd: wasAlreadySentToKitchen ? false : item.isNewAdd,
    amount_to_impress: wasAlreadySentToKitchen ? 0 : (amountToImpress > unitIndex ? 1 : 0),
  };
};

export const splitGroupsByUnit = (groups = []) => {
  const groupsByUnit = [];

  groups.forEach((group, index) => {
    if (group.amount > 1) {
      for (let i = 0; i < group.amount; i++) {
        const kitchenState = preserveSplitKitchenState(group, i);
        groupsByUnit.push({
          ...group,
          ...kitchenState,
          amount: 1,
          amount_to_impress: Number(kitchenState.amount_to_impress || 0),
          idPositionArrayNow: `group-${group.group_id}-${index}-${i}`,
          segments_string: `${group.segments_string} ${index}${i}`,
        });
      }
    } else {
      const kitchenState = preserveSplitKitchenState(group);
      groupsByUnit.push({
        ...group,
        ...kitchenState,
        amount: 1,
        amount_to_impress: Number(kitchenState.amount_to_impress || 0),
        idPositionArrayNow: `group-${group.group_id}-${index}-0`,
      });
    }
  });

  return groupsByUnit;
};

export const splitCombosByUnit = (combos = []) => {
  const combosByUnit = [];

  combos.forEach((combo, index) => {
    if (combo.amount > 1) {
      for (let i = 0; i < combo.amount; i++) {
        const kitchenState = preserveSplitKitchenState(combo, i);
        combosByUnit.push({
          ...combo,
          ...kitchenState,
          amount: 1,
          amount_to_impress: Number(kitchenState.amount_to_impress || 0),
          idPositionArrayNow: `combo-${combo.combo_id}-${index}-${i}`,
        });
      }
    } else {
      const kitchenState = preserveSplitKitchenState(combo);
      combosByUnit.push({
        ...combo,
        ...kitchenState,
        amount: 1,
        amount_to_impress: Number(kitchenState.amount_to_impress || 0),
        idPositionArrayNow: `combo-${combo.combo_id}-${index}-0`,
      });
    }
  });

  return combosByUnit;
};
